import { useEffect, useState } from "react";
import { useQuery } from "@apollo/client";

import { FETCH_MOD_LIST } from "../queries";

import useMyPhotoModProfile from "frontend/components/fort/mod/photos/hooks/useMyPhotoModProfile.js";

const useModeratorList = () => {
    const [filteredModList, updateFilteredModList] = useState([]);

    const { data: modListData } = useQuery(FETCH_MOD_LIST);
    const myModProfile = useMyPhotoModProfile();

    useEffect(() => {
        if (!modListData || !myModProfile) return;

        const { isManager, moderatorId } = myModProfile;

        // non-managers are only allowed to assign themselves to batches
        if (!isManager) {
            return updateFilteredModList(
                modListData.modList.items.filter(mod => moderatorId === mod.id)
            );
        }

        return updateFilteredModList(modListData.modList.items);
    }, [modListData, myModProfile]);

    return filteredModList;
};

export default useModeratorList;
